import React, { memo, Suspense, useCallback, useEffect, useMemo, useState } from 'react';
import { func, string } from 'prop-types';
import { HexColorPicker } from 'react-colorful';
import Tooltip from '@mui/material/Tooltip';
import SetColorVehicleWindow from './window';
import FormDialogButtons from '../../../../shared/ui/FormDialog/FormDialogButtons';
import PresetColors from './PresetColors/PresetColors';

const DEFAULT_COLOR = '000000';

function SetColorVehicle({ color = DEFAULT_COLOR, onChange, onBlur }) {
  const [isOpen, setIsOpen] = useState(false);

  const initialColor = useMemo(() => color, []);

  useEffect(() => {
    if (isOpen) return;
    onBlur();
  }, [isOpen]);

  const handleOpen = useCallback(() => setIsOpen(true), []);
  const handleClose = useCallback(() => setIsOpen(false), []);

  const handleCancel = useCallback(() => {
    onChange(initialColor);
    setIsOpen(false);
  }, [initialColor, onChange]);

  const handleClickDefault = useCallback(() => {
    onChange(DEFAULT_COLOR);
  }, [onChange]);

  const form = useMemo(
    () => (
      <div style={{ textAlign: 'center' }}>
        <PresetColors value={color} onChange={onChange} />

        <HexColorPicker
          color={`#${color}`}
          onChange={(value) => onChange(value.replace(/^#/, ''))}
          style={{ padding: '30px 0', margin: 'auto' }}
        />

        <FormDialogButtons
          cancelTitle="Отмена"
          saveTitle="По умолчанию"
          onClose={handleCancel}
          onClick={handleClickDefault}
        />
      </div>
    ),
    [color, onChange, handleCancel, handleClickDefault],
  );

  return (
    <>
      <Suspense>
        <SetColorVehicleWindow isOpen={isOpen} onClose={handleClose}>
          {form}
        </SetColorVehicleWindow>
      </Suspense>

      <Tooltip title="Редактировать цвет авто" placement="right" arrow>
        <button
          type="button"
          onClick={handleOpen}
          style={{
            width: '100px',
            height: '100px',
            background: `#${color}`,
            color: `#${color}`,
            cursor: 'pointer',
          }}
        >
          Цвет ТС
        </button>
      </Tooltip>
    </>
  );
}

SetColorVehicle.propTypes = {
  color: string.isRequired,
  onChange: func.isRequired,
  onBlur: func,
};

SetColorVehicle.defaultProps = {
  onBlur: () => {},
};

export default memo(SetColorVehicle);
